import { getRandomColor } from "utils";
import { FEAR_GREED_COLORS } from "utils/constants";
import {
  DATE_ISO_FORMAT,
  format,
  FULL_MONTH_AND_ONLY_YEAR_FORMAT,
  MONTH_YEAR_FORMAT,
  unixToDateTime,
} from "utils/date";
import { getColoredData } from "features/Strategy/utils";

const sortByDate = (data) => {
  return data.sort((a, b) => {
    const dateA = new Date(a.name);
    const dateB = new Date(b.name);
    return dateA - dateB;
  });
};

export const getSectorPerfomanceFilteredData = (data = []) => {
  const filterData = data.reduce((groups, sector) => {
    const date = sector.date;
    if (date) {
      const filterDateData = data.filter((d) => d.date === date);
      const obj = {
        name: date,
        perValue: true,
        hideTimestamp: false,
      };

      for (let index = 0; index < filterDateData.length; index++) {
        const perfomanceData = filterDateData[index];
        obj[perfomanceData.name] = perfomanceData.returns;
      }

      groups.push(obj);
    }
    return groups;
  }, []);

  const sortedData = sortByDate(filterData);

  return sortedData;
};

export const getFearGreedChartFilteredData = (data = []) => {
  let allData = [];
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if (element.x) {
      let obj = {
        name: element.x,
        ...element,
        x: unixToDateTime(element.x, DATE_ISO_FORMAT),
      };
      allData.push(obj);
    }
  }

  const sortedData = sortByDate(allData);

  return sortedData;
};

export const getFRecessionProbabilitiesChartFilteredData = (data = []) => {
  let allData = [];
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if (element.date) {
      let obj = {
        name: element.date,
        ...element,
        plainValue: true,
      };
      delete obj.x;
      allData.push(obj);
    }
  }

  const sortedData = sortByDate(allData);

  return sortedData;
};

export const getShillerPEChartFilteredData = (data = []) => {
  let allData = [];
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if (element.date) {
      let obj = {
        name: element.date,
        ...element,
        plainValue: true,
      };
      delete obj.x;
      allData.push(obj);
    }
  }

  const sortedData = sortByDate(allData);

  return sortedData;
};

export const getFearGreedIndexFilteredData = (data = []) => {
  const details = data.find((d) => d.name === "fear_and_greed");
  let color = getRandomColor();

  return {
    color,
    value: details.score,
    rating: details.rating,
  };
};

export const getFearGreedTooltipColor = (value) => {
  if (value > 80) {
    return FEAR_GREED_COLORS[80];
  } else if (value > 60) {
    return FEAR_GREED_COLORS[60];
  } else if (value > 40) {
    return FEAR_GREED_COLORS[40];
  } else if (value > 20) {
    return FEAR_GREED_COLORS[20];
  } else {
    return FEAR_GREED_COLORS[0];
  }
};

export const getTradesData = (data = {}) => {
  let filtered = [];
  for (const key in data) {
    const dateObj = new Date(key);

    if (isNaN(dateObj.getTime())) {
      console.warn("Invalid date:", key);
      continue;
    }

    const fullDate = format(MONTH_YEAR_FORMAT, dateObj);
    const value2 = parseInt(`-${data[key].sale}`);

    filtered.push({
      ...data[key],
      name: key,
      label: fullDate,
      value: data[key].purchase,
      value2,
      color: data[key].purchase > 0 ? "#2BD175" : "#FF3F3F",
      color2: value2 > 0 ? "#2BD175" : "#FF3F3F",
      hideTimestamp: true,
    });
  }
  return filtered;
};

export const getTradesDataV2 = (data = {}, type) => {
  let filtered = [];
  const isPerformance = type == "performance";
  for (const key in data) {
    const dateObj = new Date(key);

    if (isNaN(dateObj.getTime())) {
      console.warn("Invalid date:", key);
      continue;
    }

    const fullDate = format(FULL_MONTH_AND_ONLY_YEAR_FORMAT, dateObj);
    const value2 = isPerformance
      ? parseInt(`-${data[key].loss}`)
      : parseInt(`-${data[key].sale}`);

    filtered.push({
      ...data[key],
      name: key,
      label: fullDate,
      value: isPerformance ? data[key].gain : data[key].purchase,
      value2,
      color: isPerformance
        ? data[key].gain > 0
          ? "#2BD175"
          : "#FF3F3F"
        : data[key].purchase > 0
        ? "#2BD175"
        : "#FF3F3F",
      color2: value2 > 0 ? "#2BD175" : "#FF3F3F",
      hideTimestamp: true,
    });
  }
  return filtered;
};

export const getParsedSentimentChartData = (data = {}) => {
  const formattedOverallSentimentData = Object.keys(data).map((key) => ({
    name: key.replace(/^percent_/, ""),
    value: data[key],
  }));

  const sortedData = formattedOverallSentimentData.sort((a, b) => {
    const order = ["positive", "neutral", "negative"];
    return order.indexOf(a.name) - order.indexOf(b.name);
  });

  if (sortedData?.length > 0) {
    const response = getColoredData(sortedData);
    return response;
  }
};
